import { EngagementMessageType } from '../auto-email-engagement/auto-email-engagement.models';

export type SequenceFilterKey =
  | 'all'
  | 'e1Sent'
  | 'e2Sent'
  | 'e3Sent'
  | 'closed';

export interface SequenceFilterCounts {
  all: number;
  e1Sent: number;
  e2Sent: number;
  e3Sent: number;
  closed: number;
}

export interface AutoEmailEngagementSequenceCandidate {
  id?: string;
  firstName: string;
  lastName: string;
  location: string;
  email?: string | null;
  avatarUrl?: string | null;
}

export interface AutoEmailEngagementSequenceRow {
  sequenceId: string;
  candidate: AutoEmailEngagementSequenceCandidate;
  lastSentStage: EngagementMessageType;
  lastSentLabel: string;
  closedAtIso: string | null;
  nextMessageType: Extract<EngagementMessageType, 'E2' | 'E3'> | null;
  canFollowUp: boolean;
  canMarkApplied: boolean;
  canClose: boolean;
  isClosed: boolean;
  isOpened: boolean;
  isDelivered: boolean;
  hasEngagement: boolean;
  sentAtIso: string | null;
}

export interface AutoEmailEngagementSequenceStats {
  total: number;
  replied: number;
  applied: number;
  closed: number;
}

export interface AutoEmailEngagementSequencesQuery {
  vacancyId: string;
  filter?: SequenceFilterKey;
  query?: string | null;
  take?: number;
  skip?: number;
}

export interface AutoEmailEngagementSequencesResponse {
  rows: AutoEmailEngagementSequenceRow[];
  stats: AutoEmailEngagementSequenceStats;
  filterCounts?: Partial<SequenceFilterCounts>;
}

export interface SequenceListFilters {
  filter: SequenceFilterKey;
  query: string | null;
  take: number;
  skip: number;
}

export interface SequenceListParams {
  toPush: boolean;
  filters: SequenceListFilters;
}

export interface SequencesHistoryFocusRequest {
  email: string;
  candidateId: string;
}

export const SEQUENCE_CHUNK_SIZE = 50;

export const DEFAULT_SEQUENCE_FILTER_COUNTS: SequenceFilterCounts = {
  all: 0,
  e1Sent: 0,
  e2Sent: 0,
  e3Sent: 0,
  closed: 0,
};

export const DEFAULT_SEQUENCE_STATS: AutoEmailEngagementSequenceStats = {
  total: 0,
  replied: 0,
  applied: 0,
  closed: 0,
};

export const SEQUENCE_SUMMARY_CARDS = [
  {
    key: 'total' as const,
    labelKey: 'VacanciesMatch.AutoEmailEngagement.SequencesStatTotal',
  },
  // {
  //   key: 'replied' as const,
  //   labelKey: 'VacanciesMatch.AutoEmailEngagement.SequencesStatReplied',
  // },
  {
    key: 'applied' as const,
    labelKey: 'VacanciesMatch.AutoEmailEngagement.SequencesStatApplied',
  },
  {
    key: 'closed' as const,
    labelKey: 'VacanciesMatch.AutoEmailEngagement.SequencesStatClosed',
  },
];

export const SEQUENCE_FILTER_OPTIONS = [
  { key: 'all' as const, labelKey: 'Common.All' },
  {
    key: 'e1Sent' as const,
    labelKey: 'VacanciesMatch.AutoEmailEngagement.SequencesFilterE1Sent',
  },
  {
    key: 'e2Sent' as const,
    labelKey: 'VacanciesMatch.AutoEmailEngagement.SequencesFilterE2Sent',
  },
  {
    key: 'e3Sent' as const,
    labelKey: 'VacanciesMatch.AutoEmailEngagement.SequencesFilterE3Sent',
  },
  {
    key: 'closed' as const,
    labelKey: 'VacanciesMatch.AutoEmailEngagement.SequencesFilterClosed',
  },
];